import React, { useEffect } from 'react';
import styled from 'styled-components';

const CardRole = styled('div')`
  & .heading {
    color: var(--gray-900, #1f1f1f);
    font-feature-settings:
      'clig' off,
      'liga' off;
    /* Source/Body 17/Semibold */
    font-family: Source Sans Pro;
    font-size: 1.0625rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.375rem; /* 129.412% */
    padding: 20px 15px;
  }
  & .bottom-card {
    padding: 20px 15px;
  }
`;

const DetailCard = styled('div')`
  & .detail-card-heading {
    display: flex;
    justify-content: space-between;
    color: black;
    padding-bottom: 16px;
    & .left {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    & .detail-card-hotelname {
      color: var(--themes-inkblue-700, #071c3e);
      font-feature-settings:
        'clig' off,
        'liga' off;
      font-family: Source Sans Pro;
      font-size: 1.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: 1.5rem; /* 120% */
    }
    & .detail-card-experience {
      color: var(--gray-400, #919191);
      /* Source/Body 15/Regular */
      font-family: Source Sans Pro;
      font-size: 0.9375rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.25rem; /* 133.333% */
    }
  }
`;

const DetailCardComponent = ({
  setIsDetailViewOpen,
  hotelData,
  formatDate,
  hotelEntries,
}) => {
  const [isOnlyPastRolesExist, setIsOnlyPastRolesExist] = React.useState(false);

  useEffect(() => {
    setIsOnlyPastRolesExist(hotelEntries.every((value) => value.endDate));
  }, []);

  return (
    <DetailCard onClick={() => setIsDetailViewOpen(false)}>
      <div className="detail-card-heading">
        <div className="left">
          <span className="detail-card-hotelname">{hotelData.hotelName}</span>
          <span className="detail-card-experience">
            {formatDate(hotelData.startDate)} -{' '}
            {hotelData.endDate ? formatDate(hotelData.endDate) : 'Present'}
          </span>
        </div>
      </div>
      {hotelEntries.map((entry, index) => {
        return (
          // tslint:disable-next-line:jsx-key
          <div
            style={{
              border: '1px solid #e1e1e1',
              borderTop: index === 0 ? '1px solid #e1e1e1' : 'none',
              borderBottom: '1px solid #e1e1e1',
              borderTopLeftRadius: index === 0 ? '6px' : 'none',
              borderTopRightRadius: index === 0 ? '6px' : 'none',
              borderBottomLeftRadius:
                index === hotelEntries.length - 1 ? '6px' : 0,
              borderBottomRightRadius:
                index === hotelEntries.length - 1 ? '6px' : 0,
            }}
          >
            <CardRole>
              {((isOnlyPastRolesExist && index === 0) ||
                !isOnlyPastRolesExist) && (
                <div className="heading">
                  {entry.endDate ? 'Past Roles' : 'Current Role'}
                </div>
              )}
              <div
                style={{
                  borderBottom: '1px solid #e1e1e1',
                }}
              />
              <div className="bottom-card">
                <div className="subheading">
                  <div className="dept">{entry.currentJobTitle}</div>
                  <div className="expereience">
                    {formatDate(entry.startDate)} -{' '}
                    {entry.endDate ? formatDate(entry.endDate) : 'Present'}
                  </div>
                </div>
                <p className="mt-5">{entry.jobDescription}</p>
              </div>
            </CardRole>
          </div>
        );
      })}
    </DetailCard>
  );
};

export default DetailCardComponent;
